var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 0C11.7831 0 4.28442 7.49856 4.28442 16.7157C4.28442 20.2995 5.40218 23.7163 7.51695 26.5971C9.49546 29.292 12.1779 31.3021 15.2967 32.432L20.9816 42L26.9186 32.3519C33.3953 29.901 37.7158 23.6736 37.7158 16.7157C37.7158 7.49856 30.2171 0 21.0001 0ZM21.0001 27.3017C15.1629 27.3017 10.414 22.5529 10.414 16.7157C10.414 10.8785 15.1629 6.12962 21.0001 6.12962C26.8373 6.12962 31.5861 10.8785 31.5861 16.7157C31.5861 22.5529 26.8373 27.3017 21.0001 27.3017Z",
    fill: "#2776CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0001 8.59473C16.5224 8.59473 12.8796 12.2375 12.8796 16.7152C12.8796 21.1928 16.5224 24.8356 21.0001 24.8356C25.4778 24.8356 29.1205 21.1928 29.1205 16.7152C29.1205 12.2375 25.4778 8.59473 21.0001 8.59473ZM25.0847 19.0565L23.3413 20.7999L21.0001 18.4587L18.6588 20.7999L16.9154 19.0565L19.2567 16.7152L16.9154 14.374L18.6588 12.6306L21.0001 14.9718L23.3413 12.6306L25.0847 14.374L22.7435 16.7152L25.0847 19.0565Z",
    fill: "#57B8EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLost);
export default __webpack_public_path__ + "static/media/lost.5c9655f18e393bef55d9ea7d1eaf3db8.svg";
export { ForwardRef as ReactComponent };